import { render, staticRenderFns } from "./EventShow.vue?vue&type=template&id=3cc2de3e&scoped=true&"
import script from "./EventShow.vue?vue&type=script&lang=js&"
export * from "./EventShow.vue?vue&type=script&lang=js&"
import style0 from "./EventShow.vue?vue&type=style&index=0&id=3cc2de3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc2de3e",
  null
  
)

export default component.exports